<template>
  <div>
    <vs-row>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12" vs-lg="12" vs-xs="6" vs-sm="6" style="margin: 5px 0;">
        <h3>League Invitations</h3>
      </vs-col>
      <vs-col vs-w="12" vs-sm="6" vs-xs="6" vs-lg="2" style="margin: 5px 0;">
        <vs-button
          color="primary"
          type="border"
          icon="add"
          @click="createTeamForm = true"
          >Add New Team</vs-button
        >
      </vs-col>
      <vs-col vs-w="12">
        <vs-table
          search
          pagination
          :data="invites"
          max-items="25"
          description
          v-model="selected"
          :description-items="[25, 50, 100]"
          description-title="Invites"
          description-connector="of"
          description-body="Pages"
          @selected="addTeamModal"
        >
          <template slot="header">
            <vs-row>
              <vs-col
                vs-w="12"
                vs-sm="12"
                vs-xs="12"
                vs-lg="6"
                style="margin: 5px 0;"
              >
                <h5>
                  Leagues are sending you invitations to join their team.
                </h5>
                <h5>
                  Click on one of the invites to submit your team and get
                  started.
                </h5>
              </vs-col>
            </vs-row>
          </template>
          <template slot="thead">
            <vs-th sort-key="league_name">League Name</vs-th>
            <vs-th sort-key="league_city">League City</vs-th>
            <vs-th sort-key="league_state">League State</vs-th>
            <vs-th sort-key="description">Description</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="d" :key="index" v-for="(d, index) in data">
              <vs-td :data="d.league_name">{{ d.league_name }}</vs-td>
              <vs-td :data="d.league_city">{{ d.league_city }}</vs-td>
              <vs-td :data="d.league_state">{{ d.league_state }}</vs-td>
              <vs-td :data="d.description">{{ d.description }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
    <vs-popup :title="leagueName" :active.sync="addTeamForm">
      <div class="my-5">Select one of your available teams below</div>
      <div>
        <vs-select
          class="selectExample"
          label="Available Teams"
          v-model="selectedTeam"
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in availableTeams"
          />
        </vs-select>
      </div>
      <div>
        <vs-textarea
          name="description"
          v-model="description"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label="Note to League"
          class="w-full"
        />
      </div>
      <div style="margin: 10px 0 0">
        <vs-button @click="sendTeam()">
          Accept League Invitation
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Create Team" :active.sync="createTeamForm">
      <create-team
        @onSuccess="createTeamSuccess"
        @onError="createTeamForm = false"
      />
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import UserRoles from "@/mixins/UserRoles";
import CreateTeam from "@/views/pages/teams/CreateTeam";

export default {
  name: "invite-team-listing",
  components: {
    "create-team": CreateTeam
  },
  created() {
    this.loadLeagueInvites();
  },
  mixins: [UserRoles],
  data: () => ({
    invites: [],
    addTeamForm: false,
    createTeamForm: false,
    availableTeams: [],
    selected: [],
    selectedTeam: null,
    selectedInvite: null,
    description: null
  }),
  computed: {
    leagueName() {
      return this.selectedInvite && this.selectedInvite.league_name;
    }
  },
  methods: {
    ...mapActions({
      getLeagueInvites: "session/getLeagueInvites",
      getTeamSeasons: "team/getTeamSeasons",
      submitTeam: "league/acceptLeagueInvite",
      create: "league/createLeague"
    }),
    async loadLeagueInvites() {
      this.$vs.loading();
      const { json } = await this.getLeagueInvites();
      this.invites = json;
      this.$vs.loading.close();
    },
    async loadLeagueTeams() {
      this.$vs.loading();
      const { json } = await this.getTeamSeasons();
      this.availableTeams = json.map(t => ({ ...t, text: t.name, value: t }));
      this.$vs.loading.close();
    },
    async addTeamModal(l) {
      await this.loadLeagueTeams();
      this.addTeamForm = true;
      this.selectedInvite = l;
    },
    resetTeamInvite() {
      this.description = null;
      this.selectedTeam = null;
      this.selectedInvite = null;
    },
    async sendTeam() {
      const data = {
        team: this.selectedTeam,
        invite: this.selectedInvite,
        description: this.description
      };
      try {
        await this.submitTeam({ id: this.selectedInvite.id, data });
        this.$toasted.success("Successfully Accepted Invitation").goAway(2000);
      } catch (ex) {
        this.$toasted
          .error(`Already Submitted: ${ex.error || "Unable to Accept Invite"}`)
          .goAway(2000);
      } finally {
        this.addTeamForm = false;
        this.resetTeamInvite();
      }
    },
    createTeamSuccess() {
      this.createTeamForm = false;
      this.loadLeagueTeams();
    }
  }
};
</script>
